module.exports = "<div id=\"layer-thumbnail-container\">\n  <div *ngFor=\"let theme of elements\" class=\"layer-thumbnail-item\" (click)=\"toggleThematic(theme)\" >\n    <a id=\"{{theme.id}}\" class=\"thumbnail thumbnail-{{theme.state}}\" >\n      <img src=\"{{theme.thumbnail}}\" alt=\"{{theme.name}}\">\n    </a>\n    <div class=\"thumbnail-name thumbnail-name-{{theme.state}}\">{{theme.name | translate}}</div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /usr/nexus/jenkins/workspace/enmapa-geoportal-frontend/src/app/components/thumbnail-layer/thumbnail-layer.component.html
// module id = ../../../../../src/app/components/thumbnail-layer/thumbnail-layer.component.html
// module chunks = 1